import { styled, DialogContent } from '@mui/material';
import { TabPanel } from '@mui/lab';

export const AssistantGenerateRoutesDialogByItemsContentTabsContainer = styled(
  DialogContent,
)({
  display: 'flex',
  flex: 1,
});

export const AssistantGenerateRoutesDialogByItemsContentTabsPanel = styled(
  TabPanel,
)({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  flex: 1,
});
